export const COVERAGE_FACTOR = 2;
export const RESULT_DECIMALS_NUM = 8;
